exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2-italic-sm[data-v-5dfe10e0] {\n    font-size: .50em !important;\n    font-style: italic !important; \n    font-weight: normal !important;\n}\ntd[data-v-5dfe10e0] {\n    white-space: nowrap;\n}\n.fa-tags[data-v-5dfe10e0] {\n    font-size: 1.2em;\n}\n.icon-hidden[data-v-5dfe10e0] {\n   color: transparent;\n}    \n", ""]);

// exports
